module.exports = __webpack_public_path__ + "img/menu4-3.c72f48d3.svg";